import _ from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

/**
 * Create a "selector creator" that uses lodash.isEqual instead of === as the returned value for manualInputsSelector/inputsSelector
 * As they don't return a calculated values (it returns an object), so on each render equality check (=== by default) will fail
 */
const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  _.isEqual
);

const mortgageCalculatorSelector = (state) => state.mortgageCalculator;

export const manualInputsSelector = createDeepEqualSelector(
  mortgageCalculatorSelector,
  (mortgageCalculator) => mortgageCalculator.manualInputs
);

export const inputsSelector = createDeepEqualSelector(
  mortgageCalculatorSelector,
  (mortgageCalculator) => mortgageCalculator.inputs
);

export const outputsSelector = createDeepEqualSelector(
  mortgageCalculatorSelector,
  (mortgageCalculator) => mortgageCalculator.outputs
);
